module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_05_1280_1280_ko-f46dca83daefa300d3f17cbceea429f5.jpg";